import axios from "../../../core/api/http-common";

const ON_SCHOOL_CREATE = "/schools/create";
const ON_SCHOOL_GET_ALL = "/schools/get";
const ON_SCHOOL_GET_WITH_PAGINATION = "/schools/get/with/pagination";
const ON_SCHOOL_GET_RELEASE = "/schools/get/release";
const ON_SCHOOL_GET_ARCHIVE = "/schools/get/archive";

export function onCreateSchool(axiosPrivate, data) {
  console.log({"service-school-creation data":data})

  const _data = {
    title: data?.title,
    language: data?.language,
    description: data?.description,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_SCHOOL_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetSchools(axiosPrivate, signal) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_SCHOOL_GET_ALL, {
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetSchoolsWithPagination(axiosPrivate, _data, signal) {
  const data = {
    rows_per_page: _data?.rows_per_page,
    current_page: _data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_SCHOOL_GET_WITH_PAGINATION, {
        params: data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onSchoolsReleased(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_SCHOOL_GET_RELEASE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onSchoolsArchived(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_SCHOOL_GET_ARCHIVE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Streams (Classes)
//
const ON_STREAMS_CREATE = "/schools/create/streams";
const ON_STREAMS_GET_ALL = "/schools/get/streams";
const ON_STREAMS_GET_WITH_PAGINATION = "/schools/get/streams/with/pagination";
const ON_STREAMS_GET_RELEASED = "/schools/get/streams/release";
const ON_STREAMS_GET_ARCHIVED = "/schools/get/streams/archive";

export function onCreateStream(axiosPrivate, data) {
  const _data = {
    school_id: data?.school_id,
    title: data?.title,
    language: data?.language,
    description: data?.description,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_STREAMS_CREATE, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetStreams(axiosPrivate, signal) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_STREAMS_GET_ALL, {
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetStreamsWithPaginationBySchoolId(axiosPrivate, data, signal) {
  const _data = {
    school_id: data?.school_id,
    rows_per_page: data?.rows_per_page,
    current_page: data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_STREAMS_GET_WITH_PAGINATION, { params: _data, signal: signal })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onStreamsReleased(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_STREAMS_GET_RELEASED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onStreamsArchived(axiosPrivate, is_action, selectedRows, updated_at) {
  const _data = {
    is_action: is_action, // "activate" or "desactivate"
    selected_rows: selectedRows,
    updated_at: updated_at,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_STREAMS_GET_ARCHIVED, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

